import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { IAddressRegionDto } from '@classictechsolutions/hubapi-transpiled-enums';
import {
    getLotMigratorFormErrorMessage,
    hasLotMigratorFormError
} from '../lot-migrator-form-errors';
import { LOT_MIGRATOR_MAX_LENGTHS } from '../lot-migrator-max-lengths';

@Component({
    selector: 'cb-lot-migrator-address-section',
    standalone: true,
    imports: [
        CommonModule,
        ReactiveFormsModule,
        MatFormFieldModule,
        MatInputModule,
        MatSelectModule
    ],
    templateUrl: './lot-migrator-address-section.component.html',
    styleUrls: ['./lot-migrator-shared-section.styles.scss']
})
export class LotMigratorAddressSectionComponent {
    public readonly maxLengths = LOT_MIGRATOR_MAX_LENGTHS;
    @Input({ required: true }) public lotForm!: FormGroup;
    @Input() public addressRegions: IAddressRegionDto[] = [];

    public hasError(controlName: string): boolean {
        return hasLotMigratorFormError(this.lotForm, controlName);
    }

    public getErrorMessage(controlName: string, label: string): string {
        return getLotMigratorFormErrorMessage(this.lotForm, controlName, label);
    }
}
